import { PanelResizeHandle } from "react-resizable-panels";
import { cn } from "@/lib/utils";

export function ResizeHandle({ className }: { className?: string }) {
  return (
    <PanelResizeHandle
      className={cn(
        `
        mx-1 flex relative w-px items-center justify-center
        border-3 border-primary/5 bg-border opacity-100
        transition-colors duration-0 hover:border-primary/5 hover:opacity-100
        focus-visible:outline-none focus-visible:ring-ring focus-visible:ring-offset-1
        data-[panel-group-direction=vertical]:h-px
        data-[panel-group-direction=vertical]:w-full
        dark:border-primary/10 dark:hover:border-primary/10
        xl:border-primary/5 xl:opacity-0 xl:dark:border-background

        after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2
        data-[panel-group-direction=vertical]:after:left-0
        data-[panel-group-direction=vertical]:after:h-1
        data-[panel-group-direction=vertical]:after:w-full
        data-[panel-group-direction=vertical]:after:-translate-y-1/2
        data-[panel-group-direction=vertical]:after:translate-x-0

        [&[data-panel-group-direction=vertical]>div]:rotate-90
        `,
        className
      )}
    />
  );
}
